"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Http_1 = __importDefault(require("./Http"));
function install(Vue, options) {
    const http = new Http_1.default(options);
    Vue.prototype.$http = http;
}
exports.default = install;
